"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (val, max) {
    val = val % max;
    return val < 0 ? val + max : val;
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/wrapNumber.js
// module id = 347
// module chunks = 35783957827783